import axios from '@/utils/axios.js'

/**
 * 上传头像
 * @param {File} file 头像文件
 * @returns 上传结果，包含头像URL
 */
export async function uploadAvatar(file) {
  const formData = new FormData()
  formData.append('file', file)

  const { data } = await axios({
    method: 'post',
    url: '/common/upload',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  })
  return data
}

/**
 * 更新用户信息
 * @param {Object} userInfo 用户信息对象
 * @param {string} userInfo.id 用户ID
 * @param {string} userInfo.username 用户名
 * @param {string} userInfo.avatar 头像URL
 * @returns 更新结果
 */
export async function updateUserInfo(userInfo) {
  const { data } = await axios.put('/admin/user/userInfo/update', userInfo)
  return data
}